export default __webpack_public_path__ + "static/media/icon-telegram.6d1f1937.webp";